import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { motion, AnimatePresence } from "framer-motion";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { store, persistor } from "./store";
import ProjectRoutes from "./routes/routes";
// import NavBar from "./components/NabBar"; // Component not found
// import FooterLayout from "./components/FooterLayout"; // Component not found

// Wrapper component to access location inside Router
const AppContent = () => {
  const location = useLocation();
  
  // Check if current route is a dashboard, payment, or auth page
  const isDashboardPage = location.pathname.startsWith("/admin-dashboard") ||
                         location.pathname === "/DeveloperDashboard";
  const isAuthPage = location.pathname.startsWith("/login") || 
                    location.pathname.startsWith("/signup") || 
                    location.pathname.startsWith("/forgot-password") || 
                    location.pathname.startsWith("/reset-password");
  
  // Show navbar and footer only on static pages
  const shouldShowNavbar = false; // NavBar component not available
  const shouldShowFooter = false; // FooterLayout component not available

  return (
    <>
      {/* {shouldShowNavbar && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <NavBar />
        </motion.div>
      )} */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <ProjectRoutes />
      </motion.div>
      {/* {shouldShowFooter && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <FooterLayout />
        </motion.div>
      )} */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1500); // Simulate loading delay
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-white"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="rounded-full h-16 w-16 border-t-4 border-blue-500"
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          />
        </motion.div>
      } persistor={persistor}>
        <AnimatePresence>
          {loading ? (
            <motion.div
              className="fixed inset-0 flex items-center justify-center bg-white"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <motion.div
                className="rounded-full h-16 w-16 border-t-4 border-blue-500"
                animate={{ rotate: 360 }}
                transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
              />
            </motion.div>
          ) : (
            <Router>
              <AppContent />
            </Router>
          )}
        </AnimatePresence>
      </PersistGate>
    </Provider>
  );
}

export default App;
